import { css } from "@emotion/css";

import { Stack } from "@certn/cascadia-react";
import { Skeleton } from "@certn/cascadia-react/patterns/skeleton/Skeleton";

interface SkeletonGridProps {
  rows?: number;
  columns?: number;
  className?: string;
}

export function SkeletonGrid({
  rows = 3,
  columns = 3,
  className,
}: SkeletonGridProps) {
  return (
    <Stack gap="space-2" className={className}>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Stack key={rowIndex} orientation="horizontal" justify="space-between">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Skeleton key={colIndex} className={styles.skeletonItem} />
          ))}
        </Stack>
      ))}
    </Stack>
  );
}

const styles = {
  skeletonItem: css({
    flex: 1,
  }),
};
